import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutUrl } from '../../data/offer';
import { trackInitiateCheckout } from '../../utils/metaPixel';
type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'lg';
  arrow?: boolean;
  href?: string;
  target?: '_blank';
  rel?: string;
  onClick?: () => void;
  ariaLabel?: string;
};
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'lg',
  arrow = false,
  href,
  target,
  rel,
  onClick,
  ariaLabel
}: ButtonProps) {
  const styles = {
    primary: 'bg-cta text-cta-foreground shadow-lg shadow-cta/20 ring-1 ring-inset ring-black/10 transition-[background-color,transform] hover:bg-cta-hover active:scale-[0.98]',
    secondary: 'bg-surface text-foreground border border-primary/40 transition-[background-color,transform] hover:bg-surface-hover active:scale-[0.98]',
    outline: 'border-2 border-primary bg-transparent text-primary transition-colors hover:bg-surface'
  };
  const sizes = {
    sm: 'px-6 py-3.5 text-sm',
    lg: 'px-7 py-5 text-base sm:px-12 sm:py-6 sm:text-lg'
  };
  const classes = `inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl font-extrabold uppercase tracking-wide duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/50 ${styles[variant]} ${sizes[size]} ${className}`;
  if (href) {
    const handleLinkClick = () => {
      if (href === checkoutUrl) trackInitiateCheckout();
      onClick?.();
    };
    return <a href={href} target={target} rel={rel} onClick={handleLinkClick} className={classes} aria-label={ariaLabel} data-id="element-200" data-mp="1cderlik7wswi">
        {children}
        {arrow && <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-201" data-mp="17fmqpz1lhwg6" />}
      </a>;
  }
  return <button type="button" onClick={onClick} className={classes} aria-label={ariaLabel} data-id="element-202" data-mp="1lf4lcv1ko3xg">
      {children}
      {arrow && <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-203" data-mp="1hdsvqpip7ip9" />}
    </button>;
}